import type { UpsellBanner } from '@brighterly/lib-core-types/upsell/interfaces'
import type { UpsellBannerStore } from './interfaces'

import { UpsellBannerType } from '@brighterly/lib-core-types/upsell/enums'

export const getters = {
  getBanner: (state: UpsellBannerStore): UpsellBannerStore['banner'] => state.banner,
  hasBanner: (state: UpsellBannerStore): boolean => !!state.banner,
  isLoading: (state: UpsellBannerStore): UpsellBannerStore['loading'] => state.loading,
  isCompletedDemo: (state: UpsellBannerStore): boolean => state.banner?.type === UpsellBannerType.CompletedDemo,
  isBookDemo: (state: UpsellBannerStore): boolean => state.banner?.type === UpsellBannerType.BookDemo,
  getKidId: (state: UpsellBannerStore): UpsellBanner['kid_id'] | null => state.banner?.kid_id ?? null,
  getKidName: (state: UpsellBannerStore): UpsellBanner['kid_name'] | null => state.banner?.kid_name ?? null,
  getDiscipline: (state: UpsellBannerStore): UpsellBanner['discipline'] | null => state.banner?.discipline ?? null,
  getDeadline: (state: UpsellBannerStore): UpsellBanner['deadline'] | null => state.banner?.deadline ?? null,
}
